import { useEffect, useState } from 'react'
import { Banner, Link } from '@buffer-mono/popcorn'
import {
  fetchStatusIncidents,
  type Incident,
} from '../../utils/fetchStatusIncidents'

const STATUS_PAGE_URL = 'https://status.buffer.com/'

const AutomaticStatusBanner = (): JSX.Element | null => {
  const [incidents, setIncidents] = useState<Incident[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    fetchStatusIncidents()
      .then((incidents) => {
        setIncidents(incidents)
        setLoading(false)
        setError(false)
        return null
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }, [])

  if (loading || error || incidents.length === 0) {
    return null
  }

  // Show only the first incident for brevity
  const incident = incidents[0]

  if (dismissed) {
    return null
  }

  return (
    <Banner variant="warning" onDismiss={(): void => setDismissed(true)}>
      <Banner.Text>
        <strong>⚠️ Buffer Status:</strong> {incident.name} —{' '}
        {incident.last_update_message}{' '}
        <Link
          color="inherit"
          href={STATUS_PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          More details
        </Link>
      </Banner.Text>
    </Banner>
  )
}

export default AutomaticStatusBanner
